export const en = {
  companyActivityCard: {
    title: 'Company Activity',
    emptyState: "It looks like there isn't any recent company activity",
  },
}
